<template>
    <div class="layout-menu-container">
        <AppSubmenu
            class="layout-menu"
            :items="getMenuItems"
            :menuMode="menuMode"
            :parentMenuItemActive="true"
            :menuActive="active"
            :mobileMenuActive="mobileMenuActive"
            :root="true"
            @menuitem-click="onMenuItemClick"
            @root-menuitem-click="onRootMenuItemClick"
        />
    </div>
</template>

<script>
import { computed } from 'vue';
import AppSubmenu from './AppSubmenu';
import { UserPermissions } from './enums';
import useUserComposable from '@/composables/UserComposable';
import store from './store';
export default {
    name: 'AppMenu',
    components: {
        AppSubmenu: AppSubmenu,
    },
    props: {
        menuMode: String,
        active: Boolean,
        mobileMenuActive: Boolean,
    },
    setup() {
        const isGodUser = store.getters['auth/isGodUser'];
        const { checkUserPermission } = useUserComposable();

        const getMenuItems = computed(() => {
            const isCstOnly = store.getters['auth/isCstOnly'];

            if (isCstOnly) {
                return [
                    {
                        icon: 'pi pi-fw pi-home',
                        items: [
                            { label: 'Home', icon: 'pi pi-fw pi-home', to: '/', visible: true },
                            {
                                label: 'Company',
                                icon: 'pi pi-fw pi-building',
                                visible: isGodUser,
                                items: [
                                    { label: 'Company Selection', icon: 'pi pi-fw pi-list', url: '', },
                                    {
                                        label: 'Manage Company',
                                        icon: 'pi pi-fw pi-building',
                                        url: '',
                                        visible: checkUserPermission(UserPermissions.READ_COMPANY),
                                    },
                                    {
                                        label: 'Manage Company Pool',
                                        icon: 'pi pi-fw pi-sitemap',
                                        url: '',
                                    },
                                ],
                            },
                            // { label: 'Dashboard', icon: 'pi pi-fw pi-database', to: { name: 'ActiveDashboard' }, visible: checkUserPermission(UserPermissions.READ_METRIC) },
                            {
                                label: 'Manage Dashboards',
                                icon: 'pi pi-fw pi-list',
                                url: '',
                                visible: true
                            },
                        ],
                    },
                    {
                        items: [
                            {
                                label: 'Assessments',
                                icon: 'pi pi-fw pi-file',
                                items: [
                                    {
                                        label: 'Begin an Assessment',
                                        icon: 'pi pi-fw pi-list',
                                        url: '',
                                        visible: true
                                    },
                                    {
                                        label: 'Search Assessments',
                                        icon: 'pi pi-fw pi-list',
                                        url: '',
                                        visible: true
                                    },
                                    {
                                        label: 'Search Unassessed Users',
                                        icon: 'pi pi-fw pi-list',
                                        url: '',
                                        visible: true
                                    },
                                ],
                                visible: true,
                            },
                        ],
                    },
                    //add permissions here later
                    // {
                    //     label: 'Pinned Dashboards',
                    //     icon: 'pi pi-fw pi-list',
                    //     visible: true,
                    //     items: [
                    //         { label: 'Dashboard A', icon: 'pi pi-fw pi-chart-bar', to: '/1' },
                    //         { label: 'Dashboard B', icon: 'pi pi-fw pi-chart-line', to: '/2' },
                    //         { label: 'Dashboard C', icon: 'pi pi-fw pi-chart-pie', to: '/3' },
                    //     ],
                    {
                        items: [
                            {
                                label: 'Manage Forms',
                                icon: 'pi pi-fw pi-check-square',
                                items: [
                                    {
                                        label: 'Attributes',
                                        icon: 'pi pi-fw pi-list',
                                        url: '',
                                        visible: true
                                    },
                                    {
                                        label: 'Blocks',
                                        icon: 'pi pi-fw pi-list',
                                        url: '',
                                        visible: true
                                    },
                                    {
                                        label: 'Formulas',
                                        icon: 'pi pi-fw pi-list',
                                        url: '',
                                        visible: true
                                    },
                                    {
                                        label: 'Assessments',
                                        icon: 'pi pi-fw pi-list',
                                        url: '',
                                        visible: true
                                    },
                                ],
                                visible: true,
                            },
                        ],
                    },
                    // {
                    //     items: [
                    //         {
                    //             label: 'Mathematical Formulas',
                    //             icon: 'pi pi-fw pi-table',
                    //             items: [{ label: 'Add Formula', icon: 'pi pi-fw pi-pencil', to: { name: 'AddFormula' } }],
                    //             visible: checkUserPermission(UserPermissions.READ_FORMULAS),
                    //         },
                    //     ],
                    // },
                    {
                        items: [
                            {
                                label: 'Reports',
                                icon: 'pi pi-fw pi-file',
                                items: [
                                    {
                                        label: 'Manage Data Sources',
                                        icon: 'pi pi-fw pi-list',
                                        url: '',
                                    },
                                    {
                                        label: 'Manage User Groups',
                                        icon: 'pi pi-fw pi-list',
                                        url: '',
                                        visible: true
                                    },
                                    {
                                        label: 'Manage Not Tested',
                                        icon: 'pi pi-fw pi-list',
                                        url: '',
                                        visible: true
                                    },
                                    {
                                        label: 'Manage Report Metrics',
                                        icon: 'pi pi-fw pi-list',
                                        url: '',
                                        visible: true
                                    },
                                    {
                                        label: 'Manage Dashboards',
                                        icon: 'pi pi-fw pi-list',
                                        url: '',
                                    },
                                ],
                                visible: true
                            },
                        ],
                    },
                    {
                        items: [
                            {
                                label: 'Users',
                                icon: 'pi pi-fw pi-users',
                                items: [{ label: 'Manage Users', icon: 'pi pi-fw pi-list', to: '/users', }],
                                visible: checkUserPermission(UserPermissions.READ_USERS) || checkUserPermission(UserPermissions.WRITE_USERS),
                            },
                        ],
                    },
                    {
                        items: [
                            {
                                label: 'Settings',
                                icon: 'pi pi-fw pi-cog',
                                items: [
                                    {
                                        label: 'Manage Permission Groups',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'ManagePermissionGroups' }
                                    },
                                    {
                                        label: 'Manage Group Membership',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'ManageUserPermissionGroups' }
                                    },
                                    {
                                        label: 'View Permissions',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'Permissions' }
                                    },
                                    { label: 'View License', icon: 'pi pi-fw pi-list', to: { name: 'LicenseList' } },
                                ],
                                visible: isGodUser,
                            },
                        ],
                    },
                ];
            } else {
                return [
                    {
                        icon: 'pi pi-fw pi-home',
                        items: [
                            { label: 'Home', icon: 'pi pi-fw pi-home', to: '/', visible: true },
                            {
                                label: 'Company',
                                icon: 'pi pi-fw pi-building',
                                visible: isGodUser,
                                items: [
                                    { label: 'Company Selection', icon: 'pi pi-fw pi-list', to: '/companySelect' },
                                    {
                                        label: 'Manage Company',
                                        icon: 'pi pi-fw pi-building',
                                        to: '/company',
                                        visible: checkUserPermission(UserPermissions.READ_COMPANY),
                                    },
                                    {
                                        label: 'Manage Company Pool',
                                        icon: 'pi pi-fw pi-sitemap',
                                        to: { name: 'ManagePool' }
                                    },
                                ],
                            },
                            // { label: 'Dashboard', icon: 'pi pi-fw pi-database', to: { name: 'ActiveDashboard' }, visible: checkUserPermission(UserPermissions.READ_METRIC) },
                            {
                                label: 'Manage Dashboards',
                                icon: 'pi pi-fw pi-list',
                                to: { name: 'ManageDashboard' },
                                visible: true
                            },
                        ],
                    },
                    {
                        items: [
                            {
                                label: 'Hmi Reports',
                                icon: 'pi pi-fw pi-file',
                                items: [
                                    {
                                        label: 'Insight Portfolio',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'InsightPortfolio' },
                                        visible: checkUserPermission(UserPermissions.HMI_REPORT_INSIGHT_PORTFOLIO)
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        items: [
                            {
                                label: 'Assessments',
                                icon: 'pi pi-fw pi-file',
                                items: [
                                    {
                                        label: 'Begin an Assessment',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'BeginAssessment' },
                                        visible: checkUserPermission(UserPermissions.WRITE_ASSESSMENT_FORM)
                                    },
                                    {
                                        label: 'Search Assessments',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'AssessmentAnswers' },
                                        visible: checkUserPermission(UserPermissions.READ_ASSESSMENT_FORM)
                                    },
                                    {
                                        label: 'Search Unassessed Users',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'UnassessedUsers' },
                                        visible: checkUserPermission(UserPermissions.READ_ASSESSMENT_FORM)
                                    },
                                ],
                                visible: checkUserPermission(UserPermissions.READ_ASSESSMENT_FORM) || checkUserPermission(UserPermissions.WRITE_ASSESSMENT_FORM),
                            },
                        ],
                    },
                    //add permissions here later
                    // {
                    //     label: 'Pinned Dashboards',
                    //     icon: 'pi pi-fw pi-list',
                    //     visible: true,
                    //     items: [
                    //         { label: 'Dashboard A', icon: 'pi pi-fw pi-chart-bar', to: '/1' },
                    //         { label: 'Dashboard B', icon: 'pi pi-fw pi-chart-line', to: '/2' },
                    //         { label: 'Dashboard C', icon: 'pi pi-fw pi-chart-pie', to: '/3' },
                    //     ],
                    {
                        items: [
                            {
                                label: 'Manage Forms',
                                icon: 'pi pi-fw pi-check-square',
                                items: [
                                    {
                                        label: 'Attributes',
                                        icon: 'pi pi-fw pi-list',
                                        to: '/attributes',
                                        visible: checkUserPermission(UserPermissions.READ_ASSESSMENT_ATTRIBUTES)
                                    },
                                    {
                                        label: 'Blocks',
                                        icon: 'pi pi-fw pi-list',
                                        to: '/blocks',
                                        visible: checkUserPermission(UserPermissions.READ_ASSESSMENT_BLOCKS)
                                    },
                                    {
                                        label: 'Formulas',
                                        icon: 'pi pi-fw pi-list',
                                        to: '/formulas',
                                        visible: checkUserPermission(UserPermissions.READ_FORMULAS)
                                    },
                                    {
                                        label: 'Assessments',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'ManageAssessments' },
                                        visible: checkUserPermission(UserPermissions.READ_ASSESSMENT)
                                    },
                                ],
                                visible:
                                    checkUserPermission(UserPermissions.READ_ASSESSMENT_ATTRIBUTES) ||
                                    checkUserPermission(UserPermissions.READ_ASSESSMENT_BLOCKS) ||
                                    checkUserPermission(UserPermissions.READ_FORMULAS) ||
                                    checkUserPermission(UserPermissions.READ_ASSESSMENT),
                            },
                        ],
                    },
                    // {
                    //     items: [
                    //         {
                    //             label: 'Mathematical Formulas',
                    //             icon: 'pi pi-fw pi-table',
                    //             items: [{ label: 'Add Formula', icon: 'pi pi-fw pi-pencil', to: { name: 'AddFormula' } }],
                    //             visible: checkUserPermission(UserPermissions.READ_FORMULAS),
                    //         },
                    //     ],
                    // },
                    {
                        items: [
                            {
                                label: 'Reports',
                                icon: 'pi pi-fw pi-file',
                                items: [
                                    {
                                        label: 'Manage Data Sources',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'ManageDataSource' }
                                    },
                                    {
                                        label: 'Manage User Groups',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'DatasourceUserGroups' },
                                        visible: checkUserPermission(UserPermissions.READ_USER_GROUP)
                                    },
                                    {
                                        label: 'Manage Not Tested',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'SpecialUserGroups' },
                                        visible: checkUserPermission(UserPermissions.READ_USER_GROUP)
                                    },
                                    {
                                        label: 'Manage Report Metrics',
                                        icon: 'pi pi-fw pi-list',
                                        to: '/metrics',
                                        visible: checkUserPermission(UserPermissions.READ_METRIC)
                                    },
                                    {
                                        label: 'Manage Dashboards',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'ManageDashboard' }
                                    },
                                ],
                                visible: checkUserPermission(UserPermissions.READ_USER_GROUP) || checkUserPermission(UserPermissions.READ_METRIC),
                            },
                        ],
                    },
                    {
                        items: [
                            {
                                label: 'Users',
                                icon: 'pi pi-fw pi-users',
                                items: [{ label: 'Manage Users', icon: 'pi pi-fw pi-list', to: '/users' }],
                                visible: checkUserPermission(UserPermissions.READ_USERS) || checkUserPermission(UserPermissions.WRITE_USERS),
                            },
                        ],
                    },
                    {
                        items: [
                            {
                                label: 'Settings',
                                icon: 'pi pi-fw pi-cog',
                                items: [
                                    {
                                        label: 'Manage Permission Groups',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'ManagePermissionGroups' }
                                    },
                                    {
                                        label: 'Manage Group Membership',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'ManageUserPermissionGroups' }
                                    },
                                    {
                                        label: 'View Permissions',
                                        icon: 'pi pi-fw pi-list',
                                        to: { name: 'Permissions' }
                                    },
                                    { label: 'View License', icon: 'pi pi-fw pi-list', to: { name: 'LicenseList' } },
                                ],
                                visible: isGodUser,
                            },
                        ],
                    },
                ];
            }
        });
        return {
            getMenuItems,
        };
    },
    methods: {
        onMenuItemClick(event) {
            this.$emit('menuitem-click', event);
        },
        onRootMenuItemClick(event) {
            this.$emit('root-menuitem-click', event);
        },
    },
};
</script>
